import axios from 'axios';

// const addNewToken = (token) => {
//   if (!token) return;
//   console.log(token);

//   localStorage.setItem('w4w_token', token);
// }

const handleData = async (
  method = 'POST',
  endpoint,
  data = {},
  headers = {},
) => new Promise((resolve, reject) => {
  const accessToken = window.localStorage.getItem('w4w_token');

  axios({
    method,
    baseURL: `${process.env.W4W_API}/api`,
    url: endpoint,
    responseType: 'application/json',
    data,
    headers: {
      'x-access-token': accessToken,
      ...headers,
    },
  })
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      if (error.response && error.response.status === 429) return reject('Resource requested too many times. Please try again later.');

      if (error.response) {
        try {
          return reject(error.response.data.error.message);
        } catch (err) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('Critical error occured. Please try again.');
        }
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('Critical error occured. Please try again.');
    });
});

export default handleData;
